var swiper = new Swiper(".videoSwiper", {
    observer: true,  //开启动态检查器，监测swiper和slide
    serveSlideChildren: true,
    slideToClickedSlide: true,
    breakpoints: {
        280: {  
            slidesPerView: 'auto',
            spaceBetween: 0,
    
        },
        750:{
            slidesPerView: 'auto',
            spaceBetween: 0,
    
        }
    } 
});
(()=>{
    let newMain = document.querySelector('.videos_boxVideo_bottomList');//新闻容器
    
    let paginationBox =  document.querySelector('.paginationBox');//分页容器

    let newMains = document.querySelector('.videos_boxVideo_bottomLists');//新闻容器
    let paginationBoxs =  document.querySelector('.paginationBoxs');//分页容器


    let pageNumber = 9;
    let pageNumbers = 6;


    let newsDataRender = [];//每页要显示的数据
    let newsDataRenders = [];//每页要显示的数据
    let p = 1;//根据p值显示每页的数据
    let ps = 1;//根据p值显示每页的数据
    // pc
    pagecter(p, pageNumber, Math.ceil(newsData[0].models.length / pageNumber), newsData[0].models, newsData[0].type)
    
    function pagecter(p, pageNumber, pageCount, jsonbox, type) {
        console.log(jsonbox)
         //渲染页面函数
        let render = ()=>{
            newMain.innerHTML = ' ';
            newsDataRender = jsonbox.slice((p-1)*pageNumber,pageNumber*p); //每页要显示的数据,一页显示多少个
            newsDataRender.forEach((item, index) => {
                if (type === 'video') {
                    newMain.innerHTML += ` 
               
                    <div class="boxVideo_bottomBox_video" >
                        <div class="boxVideo_bottomBox_videoImg">
                            <img src="${item.img}" alt="">
                            <div class="boxVideo_bottomBox_videoSvg" onclick="boxVideoPaly(this)">
                                <svg id="图层_1" data-name="图层 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><defs><style>.yutube-1{fill:#fff;}.yutube-2{fill:red;}</style></defs><title>youtube</title><rect class="yutube-1" x="59.11" y="55.11" width="83.78" height="83.78"/><path class="yutube-2" d="M83.33,129.17V70.83l50,29.27ZM198,59.73s-2-13.88-7.95-20c-7.61-8-16.13-8-20-8.52-28-2-70-2-70-2H100s-42,0-70,2c-3.91.47-12.43.5-20,8.52C4,45.85,2,59.73,2,59.73A306.41,306.41,0,0,0,0,92.31V107.6a306.78,306.78,0,0,0,2,32.6s2,13.87,7.94,20c7.62,8,17.61,7.77,22.06,8.61,16,1.56,68,2,68,2s42-.06,70-2.1c3.92-.47,12.43-.51,20-8.53,6-6.12,7.95-20,7.95-20a306.47,306.47,0,0,0,2-32.59V92.32a306.78,306.78,0,0,0-2-32.6Z"/></svg>
                            </div>
                        </div>
                        <div class="boxVideo_bottomBox_videoUrl" style="display:none">${item.youtobeUrl}?vid=o0707aaxqy8&autoplay=true</div>
                        <div class="boxVideo_bottomBox_videoTitle my_h_24">
                            ${item.title}
                        </div>
                        <div class="boxVideo_bottomBox_videoText my_h_18">
                            <div class="boxVideo_bottomBox_videoTextSvg">
                                <img src="${item.svg}">
                            </div>
                            <div>${item.text}</div>
                        </div>
                    </div>
    
                `;
                } else if (type === 'picture') {
                    newMain.innerHTML += `
                    <div class="athlete-intro">
                        <div class="athlete-image">
                        <img src="${ item.img }">
                        </div>
                        <div class="athlete-name">
                        ${ item.name }
                        </div>
                        <div class="athlete-type-country">
                        ${ item.type } • ${ item.contry }
                        </div>
                    </div>
                `;
                }
          

            
        });
        };
        //初始化页面
        render();
        //渲染分页
        for(let i = 1;i<=pageCount;i++){
            paginationBox.innerHTML +=`<span>${i}</span>`;
        }
        // pagination.innerHTML +=`<span class="skip">跳转至 <input type="text"> </span>页`;//获取页数
        let asAll = paginationBox.querySelectorAll('span');
        //页面刚进来时第一页高亮
        asAll[p-1].classList.add('active');
        
        // if($(".paginationBox span:first-child").hasClass("active")){
        //     $(".prev").hide();
        // }else{
        //     $(".prev").show();
        // }
        // if($(".paginationBox span:last-child").hasClass("active")){
        //     $(".next").hide();
        // }else{
        //     $(".next").show();
        // }
        //遍历总页数
        asAll.forEach((item,index)=>{  
            //点击页数
            item.onclick = function () {
                console.log('item', item)
                $(document).scrollTop(600)
                    for(let j=0;j<asAll.length;j++){
                        asAll[j].classList.remove('active');
                    }
                this.classList.add('active');
                    p=index+1; //点击页数，改变p的值，以改变这个页面要显示的数据，达到分页的效果
                    render(); //重新渲染页面
                }
                // if($(".paginationBox span:first-child").hasClass("active")){
                //     $(".prev").hide();
                // }else{
                //     $(".prev").show();
                // }
                // if($(".paginationBox span:last-child").hasClass("active")){
                //     $(".next").hide();
                // }else{
                //     $(".next").show();
                // }
        });
        

         //点击上一页下一页，改变高亮
        let changePageClass = ()=>{
            for(let j=0;j<asAll.length;j++){
                asAll[j].classList.remove('active');
            }
            asAll[p-1].classList.add('active');
        };
        //上一页
        let prev = document.querySelector('.prev');
        prev.onclick = function (e) {
            $(document).scrollTop(600)
                if(p<=1){
                    // console.log(p);
                    return;
                }else{
                    p=p-1;
                    changePageClass();
                    render();
                }
            // if($(".paginationBox span:first-child").hasClass("active")){
            //     $(".prev").hide();
            // }else{
            //     $(".prev").show();
            // }
            // if($(".paginationBox span:last-child").hasClass("active")){
            //     $(".next").hide();
            // }else{
            //     $(".next").show();
            // }
        };
        //下一页
        let next = document.querySelector('.next');
        next.onclick = function () {
            $(document).scrollTop(600)
            if(p>=asAll.length){
                return;
            }
            p=p+1;
            changePageClass();
            render();
            // if($(".paginationBox span:first-child").hasClass("active")){
            // $(".prev").hide();
            // }else{
            //     $(".prev").show();
            // }
            // if($(".paginationBox span:last-child").hasClass("active")){
            //     $(".next").hide();
            // }else{
            //     $(".next").show();
            // }
        }
       
        
    }
      
    pagecters(ps,pageNumbers,Math.ceil(newsData[0].models.length/pageNumbers),newsData[0].models, newsData[0].type)
    function pagecters (ps,pageNumbers,pageCount,jsonbox, type){

         //渲染页面函数
        let render = ()=>{
            newMains.innerHTML = ' ';
            newsDataRenders = jsonbox.slice((ps-1)*pageNumbers,pageNumbers*ps); //每页要显示的数据,一页显示多少个
            newsDataRenders.forEach((item,index,)=>{
                if (type === 'video') {
                    newMains.innerHTML += ` 
               
                <div class="boxVideo_bottomBox_video" >
                    <div class="boxVideo_bottomBox_videoImg">
                        <img src="${item.img}" alt="">
                        <div class="boxVideo_bottomBox_videoSvg" onclick="boxVideoPaly(this)">
                            <svg id="图层_1" data-name="图层 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><defs><style>.yutube-1{fill:#fff;}.yutube-2{fill:red;}</style></defs><title>youtube</title><rect class="yutube-1" x="59.11" y="55.11" width="83.78" height="83.78"/><path class="yutube-2" d="M83.33,129.17V70.83l50,29.27ZM198,59.73s-2-13.88-7.95-20c-7.61-8-16.13-8-20-8.52-28-2-70-2-70-2H100s-42,0-70,2c-3.91.47-12.43.5-20,8.52C4,45.85,2,59.73,2,59.73A306.41,306.41,0,0,0,0,92.31V107.6a306.78,306.78,0,0,0,2,32.6s2,13.87,7.94,20c7.62,8,17.61,7.77,22.06,8.61,16,1.56,68,2,68,2s42-.06,70-2.1c3.92-.47,12.43-.51,20-8.53,6-6.12,7.95-20,7.95-20a306.47,306.47,0,0,0,2-32.59V92.32a306.78,306.78,0,0,0-2-32.6Z"/></svg>
                        </div>
                    </div>
                    <div class="boxVideo_bottomBox_videoUrl" style="display:none">
                        ${item.youtobeUrl}?vid=o0707aaxqy8&autoplay=true
                    </div>
                    <div class="boxVideo_bottomBox_videoTitle my_h_24">
                        ${item.title}
                    </div>
                    <div class="boxVideo_bottomBox_videoText my_h_18">
                        <div class="boxVideo_bottomBox_videoTextSvg">
                            <img src="${item.svg}">
                        </div>
                        <div>${item.text}</div>
                    </div>
                </div>

            `;
                } else if (type === 'picture') {
                    newMains.innerHTML += `
                    <div class="athlete-intro">
                        <div class="athlete-image">
                        <img src="${item.img}">
                        </div>
                        <div class="athlete-name">
                            ${item.name}
                        </div>
                        <div class="athlete-type-country">
                        <p>${item.type}</p><p>${item.contry}</p>
                        </div>
                    </div>`
                }
            
        });
        };
        //初始化页面
        render();
        //渲染分页
        for(let i = 1;i<=pageCount;i++){
            paginationBoxs.innerHTML +=`<span>${i}</span>`;
        }
        // pagination.innerHTML +=`<span class="skip">跳转至 <input type="text"> </span>页`;//获取页数
        let asAll = paginationBoxs.querySelectorAll('span');
        //页面刚进来时第一页高亮
        asAll[ps-1].classList.add('active');
      
        //遍历总页数
        asAll.forEach((item,index)=>{  
            //点击页数
            item.onclick = function () {
                console.log('item', item, index)
                $(document).scrollTop(600)
                    for(let j=0;j<asAll.length;j++){
                        asAll[j].classList.remove('active');
                    }
                this.classList.add('active');
                    ps=index+1; //点击页数，改变p的值，以改变这个页面要显示的数据，达到分页的效果
                    render(); //重新渲染页面
                }
              
        });
        

         //点击上一页下一页，改变高亮
        let changePageClass = ()=>{
            for(let j=0;j<asAll.length;j++){
                asAll[j].classList.remove('active');
            }
            asAll[ps-1].classList.add('active');
        };
        //上一页
        let prevs = document.querySelector('.prevs');
        prevs.onclick = function (e) {
            $(document).scrollTop(600)
                if(ps<=1){
                    // console.log(p);
                    return;
                }else{
                    ps=ps-1;
                    changePageClass();
                    render();
                }
      
        };
        //下一页
        let nexts = document.querySelector('.nexts');
        nexts.onclick = function () {
            $(document).scrollTop(600)
            if(ps>=asAll.length){
                return;
            }
            ps=ps+1;
            changePageClass();
            render();
           
        }
       
        
    }
       
  
  
     // tab切换
     $(".jd_videos_boxVideo_Title").click(function () {
       $(this).addClass("active").siblings("div").removeClass("active");
       var index = $(this).index();
       // 清空之前分页
       paginationBox.innerHTML = ''
       $(".videos_boxVideo_bottomBox .jd_videos_boxVideo_bottom:eq(" + index + ")").show().siblings(".jd_videos_boxVideo_bottom").hide()
     
       pagecter(p,pageNumber, Math.ceil(newsData[index].models.length/pageNumber),newsData[index].models, newsData[index].type)
        if(newsData[index].models.length>9){
            $(".pagination-container").show()
        }else{
            $(".pagination-container").hide()
        }
        
    })
    
     // tab切换
     $(".jd_videos_boxVideo_Title").click(function () {
       $(this).addClass("active").siblings("div").removeClass("active");
       var index = $(this).index();
       // 清空之前分页
       paginationBoxs.innerHTML = ''
       $(".videos_boxVideo_bottomBoxs .jd_videos_boxVideo_bottoms:eq(" + index + ")").show().siblings(".jd_videos_boxVideo_bottoms").hide()
     
       pagecters(ps,pageNumbers, Math.ceil(newsData[index].models.length/pageNumbers),newsData[index].models, newsData[index].type)
        if(newsData[index].models.length>6){
            $(".pagination-containers").show()
        }else{
            $(".pagination-containers").hide()
        }
        
    })
   

   
})()

// 视频播放
function boxVideoPaly(e){
    $(".no-focus-outline").addClass("overflowHtml")
    $(".bg-color").show()
    $(".videos_video_fixed").show();

    var viveoPC = $(e).parent().parent().find(".boxVideo_bottomBox_videoUrl").html();
    var newViveoPC = viveoPC.replace("watch?v=","embed/")
  

    $(".videos_video_fixed").children(".responsive-videos").attr("src",newViveoPC.trim())  
} 

$(".video_mid_cha").click(function(){
    $(".bg-color").hide()
    $(".videos_video_fixed").hide();
    $(".no-focus-outline").removeClass("overflowHtml")
    $(".videos_video_fixed").children(".responsive-videos").attr("src","") 
})